import React from 'react'

export default function Header() {
  return (
    <div className="bg-white h-20 rounded-b-xl flex items-center justify-center">
      <img className="h-6" src="/tablet-header-logo.svg" />
    </div>
  )
}
